var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconVirtualWans(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a510a120-e8af-4fe0-831e-67ebe9c4368b",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a009acc1-6e03-4969-81ca-b157b58a2f69",
    x1: 9,
    y1: 172.704,
    x2: 9,
    y2: 160.613,
    gradientTransform: "translate(0 -160)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#198ab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22a5cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#29bade"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#2ec9eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#31d1f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#32d4f5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.5,8.9a3.854,3.854,0,0,0-3.3-3.7A4.871,4.871,0,0,0,9.2.6,5.011,5.011,0,0,0,4.5,3.8a4.693,4.693,0,0,0-4,4.4,4.612,4.612,0,0,0,4.8,4.5h8.4A3.8,3.8,0,0,0,17.5,8.9Z",
    fill: "url(#a009acc1-6e03-4969-81ca-b157b58a2f69)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 12.9,
    r: 4.4,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7,10.1a4.6,4.6,0,0,0-6.4-.9h0a4.561,4.561,0,1,0,5.6,7.2h0A4.557,4.557,0,0,0,12.7,10.1ZM5.1,12.6A4.707,4.707,0,0,1,5.5,11H6.6a7.772,7.772,0,0,0-.2,1.6ZM7.2,11H8.7v1.6H7A7.772,7.772,0,0,1,7.2,11Zm2.1,0h1.5a7.772,7.772,0,0,1,.2,1.6H9.3Zm-.5,2.1v1.6H7.2l-.3-1.5Zm.5,0h1.8a9.971,9.971,0,0,1-.2,1.6H9.3Zm2.4,0H13a4.707,4.707,0,0,1-.4,1.6H11.5a7.772,7.772,0,0,0,.2-1.6Zm0-.5a9.971,9.971,0,0,0-.2-1.6h1.1a4.193,4.193,0,0,1,.4,1.6Zm.5-2.2h-.9a4.5,4.5,0,0,0-.6-1.2,4.428,4.428,0,0,1,1.5,1.2Zm-1.5,0H9.3V9a2.171,2.171,0,0,1,1.4,1.4ZM8.8,9v1.5H7.4A2.118,2.118,0,0,1,8.8,9Zm-2.2.7h0a5.582,5.582,0,0,1,.8-.5,3.1,3.1,0,0,0-.6,1.3H5.9A2.7,2.7,0,0,1,6.6,9.7ZM5.1,13.2H6.4a9.971,9.971,0,0,0,.2,1.6H5.5A5.349,5.349,0,0,1,5.1,13.2Zm.8,2.1h.9l.6,1.2A3.491,3.491,0,0,1,5.9,15.3Zm1.5,0H8.7v1.5a2.433,2.433,0,0,1-1.3-1.5Zm1.9,1.5V15.3h1.3a1.968,1.968,0,0,1-1.3,1.5Zm2.2-.8h0a2.622,2.622,0,0,1-.9.5,3.379,3.379,0,0,0,.6-1.2h.9A1.344,1.344,0,0,1,11.5,16Z",
    fill: "#0078d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.1,11.4A4.025,4.025,0,0,1,2.9,8.5,3.646,3.646,0,0,1,4.4,5.6L5,5.1l.5.6-.6.5A2.509,2.509,0,0,0,3.7,8.4a3.031,3.031,0,0,0,1.8,2.3Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.3,
    cy: 5.4,
    r: 1.1,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7,11.4l-.4-.7a3.259,3.259,0,0,0,1.8-2.3,2.748,2.748,0,0,0-1.2-2.2l-.6-.4.5-.6.6.4a3.071,3.071,0,0,1,1.5,2.9A4.025,4.025,0,0,1,12.7,11.4Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.6,
    cy: 5.4,
    r: 1.1,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.3,
    cy: 11.1,
    r: 1.1,
    fill: "#ce74b6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.6,
    cy: 11.1,
    r: 1.1,
    fill: "#ce74b6"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVirtualWans);
export default __webpack_public_path__ + "static/media/icon-virtual-wans.d245fd14ac84db2c5a61463cb6946b3b.svg";
export { ForwardRef as ReactComponent };